import React from 'react';
import {AnimatePresence, motion} from "framer-motion";
import {useTranslation} from "react-i18next";

// Overlay incitatif avis Google à l'arrivée sur le résultat.
// Même thème clair/sobre que le bloc avis en bas de StepResult (réutilise ses clés i18n).
const GoogleReviewOverlay = ({isOpen, placeName, onReview, onClose}) => {
    const {t} = useTranslation();

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center p-4"
                    initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}
                >
                    <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm" onClick={onClose}/>

                    <motion.div
                        initial={{y: 40, opacity: 0, scale: 0.97}}
                        animate={{y: 0, opacity: 1, scale: 1}}
                        exit={{y: 30, opacity: 0}}
                        transition={{type: 'spring', damping: 24, stiffness: 280}}
                        className="relative z-10 w-full max-w-sm bg-white rounded-3xl p-7 text-center shadow-[0_20px_40px_-10px_rgba(0,0,0,0.2)]"
                    >
                        <div className="flex justify-center text-2xl text-yellow-400 mb-3">{'★★★★★'}</div>

                        <h3 className="text-lg font-black text-slate-800 leading-tight mb-5">
                            {t('result.review_title', {name: placeName, defaultValue: 'Un avis 5★ pour {{name}} ?'})}
                        </h3>

                        <button
                            onClick={onReview}
                            className="w-full inline-flex items-center justify-center gap-3 px-4 py-3 bg-white border border-slate-200 rounded-full shadow-sm hover:border-blue-200 hover:shadow-md transition-all group"
                        >
                            <svg className="w-4 h-4" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                                <path fill="#EA4335"
                                      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                                <path fill="#4285F4"
                                      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                                <path fill="#FBBC05"
                                      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.13-1.43.35-2.09l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                                <path fill="#34A853"
                                      d="M24 48c6.48 0 11.95-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                            </svg>
                            <span className="text-sm font-bold text-slate-600 group-hover:text-blue-600 transition-colors">
                                {t('result.review_btn', 'Envoyer les étoiles')}
                            </span>
                        </button>
                        <button
                            onClick={onClose}
                            className="w-full mt-3 py-2 text-xs font-bold text-slate-400 hover:text-slate-600 transition-colors"
                        >
                            {t('result.review_modal.later', 'Plus tard')}
                        </button>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default GoogleReviewOverlay;
